import ErrorDialog from './error_dialog';

export default ErrorDialog;
